import css from 'styled-jsx/css';

/*language=SCSS*/
const staticStyles = css.global`
  @import 'src/_mixins/vars';
  @import 'src/_mixins/screen-size';

  .ClaimInfoPanelWrapper {
    .InfoWrapper {
      width: 600px;
    }
  }

  .ClaimInfoPanel {
    position: relative;
  }
`;

export default staticStyles;
